<template>
  <div class="disProfit" v-if="!worthless && isDistributor">
    <span class="disProfit__label">利润</span>
    <span class="disProfit__content">{{profitText}}</span>
  </div>
</template>
<script>
import { defineComponent } from "@nuxtjs/composition-api";

import { profitFormat } from "@/utils/product.js";

export default defineComponent({
  setup() {},
  props: ["min_profit", "max_profit"],
  computed: {
    profitText() {
      const { min_profit, max_profit } = this;
      return profitFormat(min_profit, max_profit);
    },
    worthless() {
      // 无价值
      const { min_profit, max_profit } = this;
      return max_profit == 0;
    },
    auth() {
      return this.$auth.$state;
    },
    loggedIn() {
      return this.auth.loggedIn;
    },
    isDistributor() {
      if (!this.auth.loggedIn) return false;
      return !!this.auth.user.distributor;
    },
  },
});
</script>
<style lang="scss" scoped>

.disProfit {
  display: inline-flex;
  height: 25px;
  border-radius: 5px;
  border: 1px solid #fcc419;
  //   margin-left: 10px;
  &__label {
    color: #eda205;
    font-size: 18px;
    font-weight: 500;
    padding: 0 7px;
    display: flex;
    align-items: center;
  }
  &__content {
    color: #495057;
    font-size: 18px;
    font-weight: bold;
    background-color: #fcc419;
    padding: 0 7px;
    display: flex;
    align-items: center;
  }
}

</style>
